import { useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toggleProfileMenu, showAuthModal, hideAllMenus } from "store/application/application-action";
import { IAppState } from "store/app-state";
import { metrics } from "utils/metrics";
import { fetchCurrentUser } from "store/user/user-action";
import { isAuthenticated } from "services/Auth";
import { getTabStatus, TABS } from "./helpers";
import { ApplicationFooter } from "./ApplicationFooter";

export const ApplicationFooterContainer = () => {
  const currentUserName = useSelector((state: IAppState) => state.user.currentUser?.username) || null;
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const tabStatuses = useMemo(() => getTabStatus(pathname, currentUserName), [pathname, currentUserName]);

  const getUserInfo = useCallback(() => {
    dispatch(fetchCurrentUser());
  }, [dispatch]);

  useEffect(() => {
    (async () => {
      const isAuth = await isAuthenticated();
      if (isAuth) {
        getUserInfo();
      }
    })();
  }, [getUserInfo]);

  const sendMetrics = async (tabName: string) => {
    await metrics.sendMenuButtonClicked({
      name: tabName
    });
  };

  const isTabActive = (tab: string) => tabStatuses[tab];

  const onProfileClick = useCallback(() => {
    dispatch(currentUserName ? toggleProfileMenu() : showAuthModal());
    sendMetrics(TABS.profile);
  },[dispatch, currentUserName]);

  const onSendMetricAndCloseMenu = (tabName: string) => {
    dispatch(hideAllMenus());
    sendMetrics(tabName);
  };

  return (
    <ApplicationFooter
      currentUserName={currentUserName}
      isTabActive={isTabActive}
      onProfileClick={onProfileClick}
      onSendMetricAndCloseMenu={onSendMetricAndCloseMenu}
    />
  );
};
